import SubpageLayout from "@/components/SubpageLayout";
import {
  CalendarCheck,
  AlertTriangle,
  Stethoscope,
  Utensils,
  ClipboardSignature,
  Bed,
  BellRing,
  FileBarChart,
  ShieldCheck,
} from "lucide-react";

export default function HundpensionatPage() {
  return (
    <div data-testid="page-hundpensionat">
      <SubpageLayout
        category="Hundpensionat-system"
        seoTitle="Hundpensionat-system"
        seoDescription="Hundifys CMS för hundpensionat: smart beläggning, individuella diet- och medicinjournaler, digital incheckning. Stoppar överbokningar och sparar 12 timmar i veckan."
        seoPath="/hundpensionat-system"
        heroBadge="Hundpensionat CMS"
        title="Slut på överbokningar och Excel-rörigt."
        highlightWord="Allt på ett ställe."
        subtitle="Hundifys CMS för hundpensionat och hundhotell tar dig från första bokningsförfrågan till utcheckning — utan att du tappar bort en enda kostlapp, medicindos eller signatur. Byggt för dig som driver ett seriöst hundhotell."
        heroImage="https://images.pexels.com/photos/9455270/pexels-photo-9455270.jpeg"
        ctaSource="Hundpensionat CMS"
        problem={{
          title: "Två problem som dödar marginalen i ett hundpensionat.",
          paragraphs: [
            "Det första är överbokning. Ett missat dubbel-bokat rum betyder en arg kund, ett akutbyte och oftast en gratis natt på husets bekostnad. När bokningarna kommer in via telefon, e-post, Facebook och formulär samtidigt — utan en gemensam realtidsvy — blir det inte en fråga om, utan när det händer.",
            "Det andra är individuell kost och medicin. Tikens glutenfria foder, Charlies allergi mot kyckling, Bossens insulindos klockan 07:00 och 19:00. När personalen växlar pass försvinner detaljerna i en pärm, en post-it, ett SMS. Det är då olyckorna sker — och det är då förtroendet rasar.",
            "Hundify löser båda på samma plattform. En levande beläggningskarta som låser dubbel-bokningar i sekunden, och digitala hundprofiler som följer med från incheckning till hemgång, synliga för varje anställd, varje skift.",
          ],
        }}
        workflow={{
          title: "Från bokning till hemgång — utan friktion.",
          intro:
            "Ett tydligt arbetsflöde som hela teamet följer. Inga papperslappar, ingen telefonkö och ingen frågetävling vid skiftbyte.",
          steps: [
            {
              title: "1. Live beläggningskarta",
              desc: "Hundägaren ser bara verkligt lediga rum. Systemet låser bokningen automatiskt — överbokning blir tekniskt omöjligt.",
            },
            {
              title: "2. Digital hundprofil",
              desc: "Foto, ras, vaccinationer, kost, mediciner, vet-kontakt och sociala preferenser. Allt fyllt i av ägaren via en länk innan vistelsen.",
            },
            {
              title: "3. Incheckning med signatur",
              desc: "Personalen scannar QR, läser igenom checklistan tillsammans med ägaren och får digital signatur direkt på plattan — ingen pärm.",
            },
            {
              title: "4. Daglig journal & utcheckning",
              desc: "Måltider, motionspass och medicin loggas i hundens flöde. Ägaren får sammanfattning + faktura automatiskt vid hemgång.",
            },
          ],
        }}
        stats={[
          { value: "0", label: "Överbokningar (garanterat)" },
          { value: "12 h", label: "Sparad admintid / vecka" },
          { value: "98%", label: "Kundnöjdhet hos våra hotell" },
        ]}
        features={[
          {
            icon: CalendarCheck,
            title: "Smart bokningskalender",
            desc: "Drag-and-drop över rum, dagar och rastgrupper. Buffertdagar och städpass läggs in automatiskt.",
          },
          {
            icon: AlertTriangle,
            title: "Konfliktstopp",
            desc: "Systemet förhindrar dubbel-bokningar, krock med karantänregler och bokning av rum som är ur drift.",
          },
          {
            icon: Utensils,
            title: "Kost- & utfodringsschema",
            desc: "Egen mat, husets foder, antal mål per dag, mängd per portion — synligt vid varje matplats.",
          },
          {
            icon: Stethoscope,
            title: "Medicinjournal",
            desc: "Dos, tidpunkt, signering av personal och påminnelser. Full spårbarhet om något händer.",
          },
          {
            icon: ClipboardSignature,
            title: "Digital incheckning",
            desc: "Ägaren signerar på platta eller telefon. Vaccinationsintyg laddas upp och valideras automatiskt.",
          },
          {
            icon: Bed,
            title: "Rumstilldelning",
            desc: "Tilldela enskilda rum, parboende eller grupprum. Storleksanpassa efter ras och temperament.",
          },
          {
            icon: BellRing,
            title: "Automatisk kundkommunikation",
            desc: "Bekräftelse, påminnelse 48h innan, ankomstinstruktioner och välkomstmail — utan att du lyfter ett finger.",
          },
          {
            icon: FileBarChart,
            title: "Rapporter & nyckeltal",
            desc: "Beläggning, snittpris, återkommande kunder och prognoser per månad. Underlag för att växa rätt.",
          },
          {
            icon: ShieldCheck,
            title: "GDPR & säker lagring",
            desc: "All data lagras i Sverige enligt GDPR. Behörigheter per användare, inloggning med MFA.",
          },
        ]}
        faq={[
          {
            q: "Kan jag importera mina nuvarande bokningar?",
            a: "Ja. Vi importerar bokningar och kunddata från Excel, Google Kalender, Bokadirekt och de flesta vanliga system gratis vid uppstart.",
          },
          {
            q: "Hur hanteras vaccinationsintyg?",
            a: "Ägaren laddar upp som PDF eller foto via sin profil. Systemet flaggar utgångsdatum och påminner i god tid.",
          },
          {
            q: "Funkar Hundify för riktigt stora hotell?",
            a: "Ja — våra största kunder driver över 80 rum och hanterar 300+ hundar/vecka utan problem. Enterprise-paketet stödjer flera anläggningar.",
          },
        ]}
      />
    </div>
  );
}
